import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { TreoDateRangeModule } from 'tsui/@treo';
import { SharedModule } from 'app/shared/shared.module';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatDividerModule } from '@angular/material/divider';
import { TreoNavigationModule } from 'tsui/@treo';
import { NgApexchartsModule } from 'ng-apexcharts';
import moment from 'moment';
import { TreoAutogrowModule } from 'tsui/@treo';
import { TreoFindByKeyPipeModule } from 'tsui/@treo';
import { TreoMessageModule } from 'tsui/@treo';
import { TreoCardModule } from 'tsui/@treo';
import { MatSortModule } from '@angular/material/sort';
import { NgxMapboxGLModule } from 'ngx-mapbox-gl';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { tenantsRoutes } from './tenants.routing';
import { ProjectTenantsComponent } from './tenants.component';
import { PropertyTenantsListComponent } from './list/list.component';
import { PropertyTenantsDetailsComponent } from './details/details.component';
import { PropertyTenantsAddUnitComponent } from './modals/add-unit/add-unit.component';
import { PropertyTenantsAddTenantComponent } from './modals/add-tenant/add-tenant.component';
import { PropertyTenantsRentEscalationComponent } from './modals/rent-escalation/rent-escalation.component';
import { PropertyTenantsRentScheduleComponent } from './modals/rent-schedule/rent-schedule.component';
import { LeaseDetailComponent } from './lease-detail/lease-detail.component';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import {
  TsPageHeaderModule,
  TsPaginatorModule,
  TsBreadcrumbModule,
  TsButtonModule,
  TSIconModule,
  TsBadgeModule,
  TsOverlayModule,
  TsFilterModule,
  TsPageComponent,
  TsInputComponent,
} from 'tsui';
import { TsPipesModule } from 'tsui/lib/cross-cutting/pipes/ts-pipes.module';
import { TsTableComponent } from 'tsui/lib/ts-table';

const TSUI_MODULES = [
  TsPipesModule,
  TsPageHeaderModule,
  TsPaginatorModule,
  TsBreadcrumbModule,
  TsButtonModule,
  TSIconModule,
  TsBadgeModule,
  TsOverlayModule,
  TsFilterModule,
];

@NgModule({
  declarations: [
    ProjectTenantsComponent,
    PropertyTenantsListComponent,
    PropertyTenantsAddUnitComponent,
    PropertyTenantsAddTenantComponent,
    PropertyTenantsRentEscalationComponent,
    PropertyTenantsRentScheduleComponent,
    PropertyTenantsDetailsComponent,
    LeaseDetailComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(tenantsRoutes),
    ScrollingModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatTabsModule,
    MatMenuModule,
    MatMomentDateModule,
    MatRadioModule,
    DragDropModule,
    NgApexchartsModule,
    MatSelectModule,
    CurrencyMaskModule,
    TreoNavigationModule,
    TreoAutogrowModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    TreoFindByKeyPipeModule,
    TreoMessageModule,
    TsTableComponent,
    ...TSUI_MODULES,
    TreoCardModule,
    NgxMapboxGLModule,
    MatTableModule,
    MatSortModule,
    MatDividerModule,
    MatSidenavModule,
    MatTooltipModule,
    TreoDateRangeModule,
    SharedModule,
  ],
  providers: [
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: moment.ISO_8601,
        },
        display: {
          dateInput: 'LL',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      },
    },
  ],
})
export class PropertyTenantsModule {}
